module.exports = __webpack_public_path__ + "static/media/hammer.e82ef265.png";